if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						if ( item.dataset.removing === '1' ) return;
						item.dataset.removing = '1';
						item.style.pointerEvents = 'none';
						const h = item.offsetHeight;
						item.style.maxHeight = h + 'px';
						item.style.transition = 'opacity 200ms ease, transform 250ms ease, max-height 350ms ease 100ms, margin 350ms ease 100ms, padding 350ms ease 100ms';
						item.offsetHeight; // reflow
						requestAnimationFrame(()=>{
							item.style.opacity = '0';
							item.style.transform = 'translateX(20px)';
							setTimeout(()=>{
								item.style.maxHeight = '0px';
								item.style.marginTop = '0';
								item.style.marginBottom = '0';
								item.style.paddingTop = '0';
								item.style.paddingBottom = '0';
								item.style.overflow = 'hidden';
							}, 100);
						});
						document.querySelectorAll('[data-header-cart-count]').forEach(el=>{
							const n = parseInt(el.textContent || '0', 10);
							if ( !isNaN(n) && n > 0 ) el.textContent = (n - 1);
						});
						// Decrement subtotal optimistically — parse EU prices
						(function(){
							function pp(t){
								var r=(t||'').replace(/[^0-9,.]/g,'');
								var lc=r.lastIndexOf(','),ld=r.lastIndexOf('.');
								if(lc>-1&&ld>-1)return lc>ld?parseFloat(r.replace(/\./g,'').replace(',','.'))||0:parseFloat(r.replace(/,/g,''))||0;
								if(lc>-1)return parseFloat(r.replace(',','.'))||0;
								return parseFloat(r)||0;
							}
							function fp(v){
								var s=(Math.round(v*100)/100).toFixed(2).replace('.',',');
								var p=s.split(',');
								p[0]=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,'.');
								return '\u20AC'+(p[1]==='00'?p[0]:p.join(','));
							}
							var priceEl = item.querySelector('.item-price strong, .item-price, [data-price]');
							if (!priceEl) return;
							var itemPrice = pp(priceEl.textContent);
							if (itemPrice <= 0) return;
							document.querySelectorAll('#CartTotal, [data-cart-total], [data-header-cart-total]').forEach(function(el){
								var cur = pp(el.textContent);
								var nv = Math.max(0, cur - itemPrice);
								el.textContent = fp(nv);
							});
						})();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty){

			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.textContent = response.description;
						} else {
							alert.textContent = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const freshCartForm = sectionInnerHTML.getElementById('AjaxCartForm');
					const freshCartSubtotal = sectionInnerHTML.getElementById('AjaxCartSubtotal');

					// If a remove animation is in flight, delay DOM rebuild until it ends (~450ms)
					const hasRemoving = !!document.querySelector('[data-js-cart-item][data-removing="1"]');
					const delay = hasRemoving ? 450 : 0;

					return new Promise(resolve => setTimeout(resolve, delay)).then(()=>{
					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.textContent = '';
					while (freshCartForm.firstChild) cartItems.appendChild(freshCartForm.firstChild);
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					}

					const subtotalEl = document.getElementById('AjaxCartSubtotal');
					subtotalEl.textContent = '';
					while (freshCartSubtotal.firstChild) subtotalEl.appendChild(freshCartSubtotal.firstChild);
							
					const event = new Event('cart-updated', { bubbles: true });
					this.dispatchEvent(event);

					// Refresh recommendations after cart change
					if ( document.querySelector('cart-recommendations') ) {
						document.querySelector('cart-recommendations').textContent = '';
						document.querySelector('cart-recommendations').generateRecommendations();
					}

					});  // end inner promise wrapper

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const freshCartForm = sectionInnerHTML.getElementById('AjaxCartForm');
			const freshCartSubtotal = sectionInnerHTML.getElementById('AjaxCartSubtotal');

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.textContent = '';
			while (freshCartForm.firstChild) cartItems.appendChild(freshCartForm.firstChild);
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})

			const subtotalEl = document.getElementById('AjaxCartSubtotal');
			subtotalEl.textContent = '';
			while (freshCartSubtotal.firstChild) subtotalEl.appendChild(freshCartSubtotal.firstChild);
			if ( document.querySelector('[data-js-site-cart-sidebar]') && typeof document.querySelector('[data-js-site-cart-sidebar]').show === 'function' ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').textContent = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

			document.dispatchEvent(new Event('cart-updated', { bubbles: true }));

		})

	}

}
